export default "__VITE_ASSET__CV5J7Klr__"